// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-y5YInhxT"};